module.exports = __webpack_public_path__ + "assets/images/blue-circle_dc995a0d0ce15b96da66e045e5f4dda7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/forms/blue-circle.png
// module id = 144
// module chunks = 0